import React from 'react';

const StockMagasinPicker = ({
  magasinsList,
  value,
  onChange,
  label = 'Magasin',
  required = false,
  compact = false,
}) => (
  <div className={compact ? 'space-y-2' : 'space-y-3'} data-testid="stock-magasin-picker">
    <p className="text-xs font-bold text-gray-400 uppercase tracking-wide">
      {label}
      {required && !value && <span className="text-amber-400/80 normal-case font-normal ml-1">— requis</span>}
    </p>
    <div className="flex flex-wrap gap-2 items-center">
      {magasinsList.length ? (
        magasinsList.map((m) => (
          <button
            key={m.code}
            type="button"
            onClick={() => onChange(m.code)}
            className={`px-3 py-2 min-h-[40px] rounded-lg text-xs font-bold border transition-colors ${
              value === m.code
                ? 'border-red-500/50 bg-red-950/30 text-white'
                : 'border-white/10 text-gray-400 hover:border-white/20'
            }`}
            data-testid={`magasin-pick-${m.code}`}
            title={m.name}
          >
            {m.code}
          </button>
        ))
      ) : (
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="px-3 py-2 rounded-lg bg-black/30 border border-white/10 text-white text-sm min-h-[40px]"
          data-testid="magasin-pick-select"
        >
          <option value="">— Choisir —</option>
          <option value="M1">M1</option>
          <option value="M2">M2</option>
        </select>
      )}
    </div>
  </div>
);

export default StockMagasinPicker;
